export const FORM_ELEMENT_ID = 'payment-profile-form';

export const US_FORMAT_ADDRESS_FORM = ['US'];
